var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogoBalken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.73 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f9f9d;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.75,17.81c-.18-.36-.55-.6-.97-.61H4.89c-.29.01-.56.14-.76.35-.2.21-.3.49-.29.78.02.58.51,1.04,1.07,1.04.01,0,.03,0,.04,0h8.83c.6,0,1.09-.49,1.09-1.09v-.48h-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.13,13.9c-.2.21-.3.49-.29.78.01.29.14.56.35.76.2.19.46.29.72.29.01,0,.03,0,.04,0h8.83c.6,0,1.09-.49,1.09-1.09v-.48h-.12c-.18-.36-.55-.6-.97-.61H4.89c-.29.01-.56.14-.76.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.43,0H2.3C1.04,0,0,1.03,0,2.3v19.4c0,1.27,1.04,2.3,2.3,2.3h14.13c1.26,0,2.29-1.03,2.3-2.3V2.3c0-1.27-1.04-2.3-2.3-2.3ZM10.01,9.83c.29,0,.56-.11.76-.31l1.19-1.16,1.19,1.16c.31.3.79.39,1.18.22.4-.17.67-.56.67-1V2.17h1.44c.07,0,.13.06.13.13v19.4c0,.07-.05.13-.12.13H2.3c-.07,0-.13-.06-.13-.13V2.3c0-.07.06-.13.13-.13h6.61v6.58c0,.6.49,1.09,1.09,1.09ZM12.81,6.17l-.1-.1c-.42-.41-1.1-.41-1.52,0l-.1.1v-3.99s1.72,0,1.72,0v3.99Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogoBalken);
export default __webpack_public_path__ + "static/media/catalogo_BALKEN.983dfc44dfb889ce109063a46fda3856.svg";
export { ForwardRef as ReactComponent };